(function ($) {
    let freeTrialTutorial = $("#freeTrialTutorial");
    let locationTutorial = $("#locationTutorial");
    let messageAnimationIsPlaying = false;

    // Modal Function Start

    checkDeviceScreenWidth();
    function checkDeviceScreenWidth(e) {
        if ($(window).width() < 769) {
            let customServiceLink = "https://lin.ee/hKxF3lO";
            let freeTrialLink = "https://lin.ee/9Y44FDh";

            $(".modalBtn").attr("data-target", null).attr("data-toggle", null);
            $.each($(".modalBtn"), function (index, item) {
                if (
                    item.text === "如超過三人購買，請洽詢專家" ||
                    item.text === "預約到店展示"
                ) {
                    $(this).attr("href", customServiceLink);
                }
                if (item.text === "免費試用7天") {
                    $(this).attr("href", freeTrialLink);
                }
            });
        } else {
            let customerService = "#customerService";
            let freeTrialModal = "#freeTrialModal";
            $.each($(".modalBtn"), function (index, item) {
                if (
                    item.text === "如超過三人購買，請洽詢專家" ||
                    item.text === "預約到店展示"
                ) {
                    $(this).attr({
                        href: "#",
                        "data-target": customerService,
                        "data-toggle": "modal",
                    });
                }
                if (item.text === "免費試用7天") {
                    $(this).attr({
                        href: "#",
                        "data-target": freeTrialModal,
                        "data-toggle": "modal",
                    });
                }
            });
        }
    }

    $(window).resize(function (e) {
        checkDeviceScreenWidth(e);
    });

    // Tutorial Click Event
    $(".tutorial").click(function () {
        $(this).children().fadeToggle();
    });

    // Init Tutorial State
    $("#customerService, #freeTrialModal").on("hidden.bs.modal", function (e) {
        $(".tutorial").children().fadeOut();
    });
    $(document).mouseup(function (e) {
        if (
            !freeTrialTutorial.is(e.target) &&
            freeTrialTutorial.has(e.target).length === 0
        ) {
            freeTrialTutorial.fadeOut();
        }
        if (
            !locationTutorial.is(e.target) &&
            locationTutorial.has(e.target).length === 0
        ) {
            locationTutorial.fadeOut();
        }
    });

    // Modal Function End

    // SideBar Navigation Start
    const areaArr = [
        "videoContainer",
        "topSalesContainer",
        "functionalContainer",
        "recommendContainer",
        "planContainer",
    ];

    $(".sidebarContainer").fadeOut();

    $.each(areaArr, function (idx, val) {
        $(`.sidebarContainer-item:eq(${idx})`).click(function (e) {
            $("html,body").animate(
                {
                    scrollTop: $(`.${val}`).offset().top + 5,
                },
                1000
            );
        });
    });

    $(".sidebarContainer-gotop").click(function (e) {
        $("html,body").animate(
            {
                scrollTop: 0,
            },
            1000
        );
    });
    // SideBar Navigation End

    window.addEventListener("scroll", winScroll);
    function winScroll(e) {
        let $now_Top = $(window).scrollTop();
        let $now_bottom = $now_Top + $(window).height();

        function scrollToChangeSidebarItem(currentItem) {
            let idx = areaArr.indexOf(currentItem);
            let hadClass = $(`.${currentItem}`).hasClass("active");

            if (!hadClass) {
                $(".sidebarContainer-item").removeClass("active");
                $(`.sidebarContainer-item:eq(${idx})`).addClass("active");
            }
        }

        function messageAnimationStart() {
            let master = new TimelineMax();
            let messageContainerHeight = $(
                ".messageAnimationContainer"
            ).height();

            $.each($(".salesMessageItem"), function (idx, val) {
                $(this).css("bottom", -$(this).height());
            });

            messageAnimationIsPlaying = true;

            if ($(window).width() > 1023) {
                master
                    .add(desktopAnimation(1), "firstMessageIn")
                    .add(desktopAnimation(2), "firstMessageIn+=2")
                    .add(desktopAnimation(3), "firstMessageIn+=4")
                    .add(desktopAnimation(4), "firstMessageIn+=6")
                    .add(desktopAnimation(5), "firstMessageIn+=8");
            } else {
                master
                    .add(mobileAnimation(1), "firstMobileMessageIn")
                    .add(mobileAnimation(2), "firstMobileMessageIn+=2")
                    .add(mobileAnimation(3), "firstMobileMessageIn+=4")
                    .add(mobileAnimation(4), "firstMobileMessageIn+=6")
                    .add(mobileAnimation(5), "firstMobileMessageIn+=8");
            }

            master.repeat(-1);

            function mobileAnimation(i) {
                const tl = new TimelineMax();

                if (i == 5) {
                    tl.fromTo(
                        `.item-${i}`,
                        { opacity: 0, y: 0 },
                        {
                            opacity: 1,
                            y: function (index, target, targets) {
                                let itemHeight = target.offsetHeight;
                                return -(
                                    messageContainerHeight / 2 +
                                    itemHeight / 2
                                );
                            },
                            duration: 2,
                        }
                    );
                } else {
                    tl.fromTo(
                        `.item-${i}`,
                        { opacity: 0, y: 0 },
                        {
                            opacity: 1,
                            y: function (index, target, targets) {
                                let itemHeight = target.offsetHeight;
                                return -(
                                    messageContainerHeight / 2 +
                                    itemHeight / 2
                                );
                            },
                            duration: 2,
                        }
                    ).to(`.item-${i}`, {
                        opacity: 0,
                        y: function (index, target, targets) {
                            let itemHeight = target.offsetHeight;
                            return -(messageContainerHeight + itemHeight);
                        },
                        duration: 2,
                    });
                }

                return tl;
            }

            function desktopAnimation(i) {
                const tl = new TimelineMax();

                switch (i) {
                    case 4:
                        tl.fromTo(
                            `.item-${i}`,
                            { opacity: 0, y: 0 },
                            {
                                opacity: 1,
                                y: function (index, target, targets) {
                                    let itemHeight = target.offsetHeight;
                                    return -(
                                        messageContainerHeight / 2 +
                                        itemHeight / 2
                                    );
                                },
                                duration: 2,
                            }
                        ).to(`.item-${i}`, {
                            opacity: 0.3,
                            y: function (index, target, targets) {
                                let itemHeight = target.offsetHeight;
                                return -(
                                    messageContainerHeight +
                                    itemHeight / 2
                                );
                            },
                            duration: 2,
                        });
                        break;
                    case 5:
                        tl.fromTo(
                            `.item-${i}`,
                            { opacity: 0, y: 0 },
                            {
                                opacity: 1,
                                y: function (index, target, targets) {
                                    let itemHeight = target.offsetHeight;
                                    return -(
                                        messageContainerHeight / 2 +
                                        itemHeight / 2
                                    );
                                },
                                duration: 2,
                            }
                        );
                        break;
                    default:
                        tl.fromTo(
                            `.item-${i}`,
                            { opacity: 0, y: 0 },
                            {
                                opacity: 1,
                                y: function (index, target, targets) {
                                    let itemHeight = target.offsetHeight;
                                    return -(
                                        messageContainerHeight / 2 +
                                        itemHeight / 2
                                    );
                                },
                                duration: 2,
                            }
                        )
                            .to(`.item-${i}`, {
                                opacity: 0.3,
                                y: function (index, target, targets) {
                                    let itemHeight = target.offsetHeight;
                                    return -(
                                        messageContainerHeight +
                                        itemHeight / 2
                                    );
                                },
                                duration: 2,
                            })
                            .to(`.item-${i}`, {
                                opacity: 0,
                                y: function (index, target, targets) {
                                    let itemHeight = target.offsetHeight;
                                    return -(
                                        messageContainerHeight + itemHeight
                                    );
                                },
                                duration: 2,
                            });
                        break;
                }

                return tl;
            }
        }

        if ($now_bottom >= $(".topSalesContainer").offset().top) {
            $(".sidebarContainer").fadeIn();
        } else {
            $(".sidebarContainer").fadeOut();
        }

        if ($now_bottom >= $(".recommendContainer").offset().top) {
            if (!messageAnimationIsPlaying) {
                messageAnimationStart();
            }
        }

        if ($now_Top >= $(".planContainer").offset().top) {
            scrollToChangeSidebarItem("planContainer");
        } else if ($now_Top >= $(".recommendContainer").offset().top) {
            scrollToChangeSidebarItem("recommendContainer");
        } else if ($now_Top >= $(".functionalContainer").offset().top) {
            scrollToChangeSidebarItem("functionalContainer");
        } else if ($now_Top >= $(".topSalesContainer").offset().top) {
            scrollToChangeSidebarItem("topSalesContainer");
        } else if ($now_Top >= $(".videoContainer").offset().top) {
            scrollToChangeSidebarItem("videoContainer");
        }
    }
})($);
